import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../App.css';
import '../Tabs.css';
import AutocompletePaginado from './AutocompletePaginado';
import Button from '@mui/material/Button';
import 'rsuite/DatePicker/styles/index.css';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';
import PrintIcon from '@mui/icons-material/Print';

import { handleErrors, request } from '../utils/ApiUtils';
import Input from './Input';
import { getActualDate } from '../utils/DateUtils';
import Table from './Table';
import { formatToBRL } from '../utils/MonetaryUtils';
import AutoCompleteMultiple from './AutoCompleteMultiple';
import CollapsibleFilters from './CollapsibleFilters';
import { getStatusBadgeStyle } from '../utils/StatusStyleUtils';
import { FaHandHoldingUsd } from 'react-icons/fa';

function ComissaoForm() {
    const navigate = useNavigate();
    const [contrato, setContrato] = useState({ data: getActualDate(), vencimentoPrimeiraParcela: getActualDate() })
    const [error, setError] = useState({})
    const [fetchListError, setFetchListError] = useState();
    const [comissao, setComissao] = useState({})
    const [ano, setAno] = useState(null)
    const [meses, setMeses] = useState([])
    const [status, setStatus] = useState({ "status": "Pendente", "color": 'orange' })
    const [colaborador, setColaborador] = useState(null);
    const [loading, setLoading] = useState({loading: false});

    useEffect(() => {
        const dataAtual = new Date();

        const anoAtual = dataAtual.getFullYear(); // Ex: 2025
        const mesAtual = dataAtual.getMonth() + 1;

        setAno(anoAtual)
        setMeses([{ id: mesAtual }])
    }, []);

    const findComissoes = async () => {
        setLoading({loading: true});

        request(`comissao`, {
            type: 'POST',
            body: JSON.stringify({
                ano: ano,
                meses: meses.map(m => m.id),
                statusParcela: status,
                colaboradorId: colaborador?.id
            }),
            callback: (data) => (
                setComissao(data),
                setLoading({loading: false})

            ),
            callbackError: (responseData, message) => {
                handleErrors(responseData, 'Falha ao consultar comissões, por favor, atualize a tela ou tente novamente.  \n' + message, {setError, setFetchListError});
                setLoading({loading: false});
            }

        })
    };

    const pdf = async () => {
        setLoading({loading: true, text: 'Gerando relatório de comissões em PDF'});

        request(`comissao/print`, {
            type: 'POST',
            readMethod: 'blob',
            body: JSON.stringify({
                ano: ano,
                meses: meses.map(m => m.id),
                statusParcela: status,
                colaboradorId: colaborador?.id
            }),
            callback: async (blob) => {

                // Cria URL temporária
                const url = window.URL.createObjectURL(blob);

                // Cria link para download
                const link = document.createElement("a");
                link.href = url;
                link.download = "comissoes.pdf";

                document.body.appendChild(link);
                link.click();

                // Limpa memória
                link.remove();
                window.URL.revokeObjectURL(url);
            },
            callbackError: (responseData, message) => { handleErrors(responseData, 'Falha ao gerar o pdf de comissões: '+message, setError) },
            finally: () => setLoading({loading: false})

        })
    };

    const footerTotals = () => (
        <div >
            <h4 style={{ fontStyle: 'bold' }}>{`Total: ${formatToBRL(comissao?.valorTotal)}`}</h4>
        </div>
    )

    const tableParams = {
        query: (page) => findComissoes(page),
        hasFooter: true,
        columns: [
            {
                label: "Nº Contrato",
                width: "8%",
                type: "input",
                disable: true,
                key: "numeroContrato"
            },
            {
                label: "Cliente",
                width: "27%",
                type: "input",
                disable: true,
                key: "cliente"
            },
            {
                label: "Colaborador",
                width: "18%",
                type: "input",
                disable: true,
                key: "colaborador"
            },
            {
                label: "Status contrato",
                width: "12%",
                type: "input",
                css: "status-badge",
                disable: true,
                // style: (item) => getStatusBadgeStyle(item.statusContrato),
                key: "statusContrato"
            },
            {
                label: "Nº Parcela",
                width: "8%",
                type: "input",
                disable: true,
                key: "numeroParcela"
            },
            {
                label: "Valor parcela",
                width: "12%",
                disabled: true,
                type: "input-decimal",
                css: "decimal",
                key: "valor",
                // showTotalValueFooter: true
                htmlFooter: () => footerTotals(),

            },
            {
                label: "Status parcela",
                width: "11%",
                type: "input",
                css: "status-badge",
                disable: true,
                // style: getStatusBadgeStyle,
                style: (item) => (
                            {
                                color: 'black',
                                // fontWeight: 'bold',
                                backgroundImage: `radial-gradient(circle, ${item?.color || 'black'} 45%, transparent 50%)`,
                                backgroundPosition: '8px center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '14px 14px',
                                paddingLeft: '28px'
                            }
                        ),
                key: "status"
            },
            {
                label: "Data vencimento",
                width: "9%",
                type: "date",
                disabled: true,
                key: "dataVencimento"
            },

            {
                label: "Contrato",
                width: "5%",
                type: "button-icon",
                css: "button",
                icon: (<VisibilityIcon />),
                onClick: (comissao) => window.open(`/contratos/cadastro/${comissao.contratoId}`)
            }
        ]
    };

    return (
        <div className="form-container">

            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex,",
                flexDirection: "column-reverse",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                bottom: "0,",
                right: "30px",
                maxHeight: "100vh"
            }}></div>

            <div className="header-container">
                <div className="page-title-content">
                    <FaHandHoldingUsd aria-hidden="true" />
                    <h1 style={{ color: 'black'}}>Comissões</h1>
                </div>
            </div>
            {/* </div> */}

            <CollapsibleFilters>
            <div className='row-with-auto-complete'>
                <AutocompletePaginado label={"Colaborador"}
                    parameters={{
                        width: '20%',
                        error: error?.captador,
                        bodyToSearch: { somenteAtivos: true },
                        getLabel: ((item) => item.nome),
                        onChange: (itemSelecionado) => setColaborador(itemSelecionado?.item),
                        value: contrato?.captador,
                        bodyToSearch: { somenteAtivos: true },
                        inputStyle: () => (
                            { fontSize: '10px' }
                        )
                    }}
                    endpoint={"colaboradores/paginated"} />

                <AutoCompleteMultiple
                    label="Meses"
                    // multiple={true}
                    disableClearable={true}
                    multiple
                    value={meses}
                    width={`${Math.min(12 + Math.max(0, (meses.length - 2) * 3), 50)}%`}
                    options={[{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }, { id: 11 }, { id: 12 }]}
                    getLabel={(item) => `${item ? item.id : ''}`}
                    onChange={(value) => {
                        setError({ ...error, meses: [] })
                        setMeses(value);
                    }} />

                <Input id="ano"
                    value={ano}
                    parameters={{
                        error: error.ano, width: '7%', max: 3000, type: 'number', label: "Ano*", onChange: (value) => {
                            setError({ ...error, ano: undefined })
                            setAno(value)
                        }
                    }} />


                <AutocompletePaginado label={"Status"}
                    parameters={{
                        width: '15%',
                        bodyToSearch: { statusParcela: true },
                        getLabel: ((item) => (item.status)),
                        onChange: (statusSelecionado) => setStatus(statusSelecionado?.item),
                        value: status,
                        inputStyle: (status) => (
                                status ?
                            {
                                color: 'black',
                                // fontWeight: 'bold',
                                backgroundImage: `radial-gradient(circle, ${status?.item?.color || 'black'} 45%, transparent 50%)`,
                                backgroundPosition: '8px center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '14px 14px',
                                paddingLeft: '28px'
                            } : {}
                        )
                    }}
                    endpoint={"contratos/status"} />

                {!!ano && !!meses &&

                    <button className="search-button" type="button" disabled={!!loading?.loading} onClick={() => findComissoes()}>
                        <SearchIcon fontSize="small" />
                    </button>
                }

                <button className="search-button" type="button" disabled={!!loading?.loading} onClick={() => pdf()}>
                    <PrintIcon fontSize="small" />
                </button>
            </div>
            </CollapsibleFilters>

            <Table params={tableParams} dataArray={comissao?.parcelas || []} loading={loading} errorOccurred={fetchListError} />
        </div>
    );
}

export default ComissaoForm;
